import { ArrowUp } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { CONTACT, IMAGES } from "@/lib/content";

export default function Footer() {
  const { t } = useSite();
  return (
    <footer className="relative bg-neutral-950 text-white pt-24 pb-10 overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 border-b border-white/10 pb-14">
          <div>
            <div className="flex items-center gap-3">
              <img src={IMAGES.ibkLogo} alt="IBK Logo" className="h-12 w-auto" />
              <span className="font-serif text-2xl">Immobilienbetreuung Kern</span>
            </div>
            <p className="mt-5 font-serif text-3xl sm:text-4xl text-white/90 max-w-lg leading-tight">{t.footer.tagline}</p>
          </div>
          <a href="#home" data-testid="footer-back-top" className="group inline-flex items-center gap-3 text-sm font-semibold text-white/70 hover:text-white transition-colors">
            <span className="grid place-items-center h-11 w-11 rounded-full border border-white/20 group-hover:border-ibk group-hover:bg-ibk transition-colors">
              <ArrowUp size={16} />
            </span>
            {t.footer.back}
          </a>
        </div>

        <div className="grid sm:grid-cols-3 gap-8 py-12 text-sm">
          <div>
            <span className="block text-xs uppercase tracking-[0.25em] text-white/40 mb-3">{t.contact.address}</span>
            <a href={CONTACT.maps} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-ibk transition-colors">{CONTACT.address}</a>
          </div>
          <div>
            <span className="block text-xs uppercase tracking-[0.25em] text-white/40 mb-3">{t.contact.phone} · {t.contact.email}</span>
            <a href={CONTACT.phoneHref} className="block text-white/80 hover:text-ibk transition-colors">{CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.email}`} className="block text-white/80 hover:text-ibk transition-colors break-all">{CONTACT.email}</a>
          </div>
          <div>
            <span className="block text-xs uppercase tracking-[0.25em] text-white/40 mb-3">{t.portal.label}</span>
            <a href={CONTACT.portal} target="_blank" rel="noopener noreferrer" data-testid="footer-portal-link" className="text-ibk hover:underline underline-offset-4">{t.portal.cta}</a>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between gap-3 pt-6 border-t border-white/10 text-xs text-white/40">
          <span>© {new Date().getFullYear()} Immobilienbetreuung Kern. {t.footer.rights}</span>
          <span>Neuffen · Stuttgart · Kirchheim u. Teck</span>
        </div>
      </div>
    </footer>
  );
}
